<style lang="scss">
  #groups {
    display: grid;
    grid-auto-rows: max-content;
    gap: 1.2rem;
  }
</style>

<script>
  import { trainingHubTaskStore } from "../../../api-stores/training-hub-store";

  import SkeletonLoader from "./Components/SkeletonLoader.svelte";
  import TaskGroup from "./TaskGroup.svelte";

  const { meta } = trainingHubTaskStore;
</script>

{#if $trainingHubTaskStore.taskGroups}
  <section id="groups">
    {#if !$meta.firstFetchDone}
      <SkeletonLoader type="task-group" />
    {:else}
      {#each $trainingHubTaskStore.taskGroups || [] as taskGroup}
        <TaskGroup {taskGroup} />
      {/each}
    {/if}
  </section>
{/if}
